import PlacowkaCard from '@/widgets/PlacowkaCard'
import PlacowkaPicker from '@/widgets/PlacowkaPicker'

export default function RozmowaPlacowkaSection({ selectedPlacowka, onSelectPlacowka, onClearPlacowka, t }) {
	return (
		<div>
			<div className="mb-4 text-sm text-gray-600">
				{t('conversations.add.placowkaLabel')}:
				<span className="ml-1 font-medium text-gray-900">{selectedPlacowka?.nazwa || '-'}</span>
			</div>

			{!selectedPlacowka && <PlacowkaPicker onPlacowkaSelect={onSelectPlacowka} />}

			{selectedPlacowka && (
				<PlacowkaCard
					placowkaData={selectedPlacowka}
					handleChange={onClearPlacowka}
				/>
			)}
		</div>
	)
}
